$bog_vmap_app_layers $mol_scroll
	source \
	root \
	doc_key \
	picked? /string
	inner? \
	inner_kids* /string
	inner_class* \
	inner_alien* false
	node_title? \
	node_title_note \
	tree_move? null
	node_show? null
	editable true
	Doc $bog_vmap_lang_doc
		source <= source
	sub /
		<= Rows $mol_list
			rows <= rows /$mol_view
	Note $mol_status
		status <= node_title_note
	Outside $mol_check_expand
		level 1
		title \Вне страницы
		expanded? <=> outside_expanded? true
	Row* $mol_drag
		allow_copy false
		allow_link false
		attr *
			^
			draggable <= row_draggable* true
		transfer *
			^
			text/plain <= row_name* \
		Sub <= Row_drop* $mol_drop
			allow /
				\move
			adopt? <=> row_adopt? null
			receive? <=> row_receive*? null
			Sub <= Line* $mol_view
				attr *
					^
					bog_vmap_app_layers_line_zone <= row_zone*? \
					bog_vmap_app_layers_line_shade <= row_shade* \
				event *
					^
					dragover? <=> row_over*? null
				sub <= row_content* /$mol_view
	Expand* $mol_check_expand
		level <= row_level* 1
		expanded? <=> row_expanded*? false
	Pick* $mol_check
		Icon <= row_icon* null
		title <= row_title* \
		hint <= row_hint* \
		checked <= row_picked* false
		click? <=> row_pick*? null
		clicks? <=> row_edit*? null
	Edit* $mol_string
		hint \имя узла
		value? <=> row_draft*? \
		submit? <=> row_submit*? null
		event *
			^
			blur? <=> row_submit*? null
			keydown? <=> row_key*? null
	Root_icon $mol_icon_file_document_outline
	Frame_icon* $mol_icon_artboard
	Image_icon* $mol_icon_image
	Link_icon* $mol_icon_link
	Button_icon* $mol_icon_button_cursor
	Field_icon* $mol_icon_form_textbox
	Text_icon* $mol_icon_format_text
	Part_icon* $mol_icon_shape_outline
